import { useState } from 'react';
import { PageHeader } from '@/components/ui/page-header';
import { Tabs, type TabDef } from '@/components/ui/tabs';
import { useCurrentUser } from '@/lib/auth';
import { usePageTitle } from '@/lib/use-page-title';
import { ClientsPanel, DepartmentsPanel } from '@/pages/settings';

type ClientsModuleTab = 'clients' | 'departments';

const TABS: TabDef<ClientsModuleTab>[] = [
  { id: 'clients', label: 'Clients' },
  { id: 'departments', label: 'Departments & Sub-departments' },
];

export function ClientsPage() {
  usePageTitle('Clients');
  const me = useCurrentUser();
  const isAdmin = me.data?.user.role === 'ADMIN';
  const [tab, setTab] = useState<ClientsModuleTab>('clients');

  return (
    <>
      <PageHeader
        title="Clients"
        subtitle={
          isAdmin
            ? 'Manage client master records and their client-specific departments/sub-departments.'
            : 'View client master records and their client-specific departments/sub-departments.'
        }
      />
      <Tabs<ClientsModuleTab> tabs={TABS} activeId={tab} onChange={setTab} className="mb-6" />
      {tab === 'clients' ? <ClientsPanel canMutate={isAdmin} /> : null}
      {tab === 'departments' ? <DepartmentsPanel canMutate={isAdmin} /> : null}
    </>
  );
}
